import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import CheckCircle from "@mui/icons-material/CheckCircle";
import Cancel from "@mui/icons-material/Cancel";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import StorageIcon from "@mui/icons-material/Storage";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import SecurityIcon from "@mui/icons-material/Security";
import HelpIcon from "@mui/icons-material/Help";
const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	"&:not(:last-child)": {
		borderBottom: 0,
	},
	"&:before": {
		display: "none",
	},
}));

const AccordionSummary = styled((props) => (
	<MuiAccordionSummary
		expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
		{...props}
	/>
))(({ theme }) => ({
	backgroundColor:
		theme.palette.mode === "dark"
			? "rgba(255, 255, 255, .05)"
			: "rgba(0, 0, 0, .03)",
	flexDirection: "row-reverse",
	"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
		transform: "rotate(90deg)",
	},
	"& .MuiAccordionSummary-content": {
		marginLeft: theme.spacing(1),
	},
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function CustomizedAccordions() {
	const [panel1, setpanel1] = React.useState(true);
	const [panel2, setpanel2] = React.useState(true);
	const [panel3, setpanel3] = React.useState(true);
	const [panel4, setpanel4] = React.useState(true);
	const [panel5, setpanel5] = React.useState(true);
	const [panel6, setpanel6] = React.useState(true);
	const [panel7, setpanel7] = React.useState(true);
	const [panel8, setpanel8] = React.useState(true);
	const [panel9, setpanel9] = React.useState(true);

	return (
		<div className="camparision">
			<td className="hide" style={{ color: "#e1fffe" }}>
				<img src="/Images/support_background.svg" alt="" />
			</td>
			<div className="d-flex comparision-head">
				<td>
					<span>ClubStart</span>
					<div>₹ 99/mo</div>
					<a
						class="btn btn-primary ctabtn "
						href="http://my.clubhosty.com/cart.php?a=add&pid=92&billingcycle=monthly"
					>
						Select Plan
					</a>
				</td>
				<td>
					<span>ClubProfessional</span>
					<div>₹ 129/mo</div>
					<a
						class="btn btn-primary ctabtn"
						href="http://my.clubhosty.com/cart.php?a=add&pid=93&billingcycle=monthly"
					>
						Select Plan
					</a>
				</td>
				<td>
					<span>ClubElite</span>
					<div>₹ 169/mo</div>
					<a
						class="btn btn-primary ctabtn"
						href="http://my.clubhosty.com/cart.php?a=add&pid=94&billingcycle=monthly"
					>
						Select Plan
					</a>
				</td>
			</div>
			<Accordion
				expanded={panel1}
				onChange={() => {
					setpanel1(!panel1);
				}}
			>
				<AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
					<Typography>
						<OpenWithIcon className="comp-title-icon" />
						Web Hosting Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>Disk Space</td>
									{/* <td>
										<CheckCircle color="success" />
									</td> */}
									<td>10 GB NVMe SSD</td>
									<td>50 GB NVMe SSD</td>
									<td>100 GB NVMe SSD</td>
								</tr>
								<tr>
									<td>File (Inode) Limit</td>
									{/* <td>
										<Cancel color="error" />
									</td> */}
									<td>Unlimited</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Bandwidth</td>
									<td>Unmetered</td>
									<td>Unmetered</td>
									<td>Unmetered</td>
								</tr>
								<tr>
									<td>Uptime</td>
									<td>99.99%</td>
									<td>99.99%</td>
									<td>99.99%</td>
								</tr>
								<tr>
									<td>Hosted Domains</td>
									<td>1</td>
									<td>10</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Parked Domains</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Subdomains</td>
									<td>5</td>
									<td>20</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Offsite Backups</td>
									<td>Last 7 Days</td>
									<td>Last 7 Days</td>
									<td>Last 7 Days</td>
								</tr>
								<tr>
									<td>cPanel (Control Panel)</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>cPanel 2FA</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Free Apps</td>
									<td>400+ apps with 1-click install</td>
									<td>400+ apps with 1-click install</td>
									<td>400+ apps with 1-click install</td>
								</tr>
								<tr>
									<td>FTP Users</td>
									<td>2</td>
									<td>15</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Money-Back Guarantee</td>
									<td>30 days</td>
									<td>30 days</td>
									<td>30 days</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel2}
				onChange={() => {
					setpanel2(!panel2);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<Inventory2Icon className="comp-title-icon" />
						Control Panel Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>Backup Manager</td>
									<td>JetBackup</td>
									<td>JetBackup</td>
									<td>JetBackup</td>
								</tr>
								<tr>
									<td>Virus Scanner</td>
									<td>Immunify360</td>
									<td>Immunify360</td>
									<td>Immunify360</td>
								</tr>
								<tr>
									<td>Hotlink Protection</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Server Status Viewer</td>
									<td>NA</td>
									<td>NA</td>
									<td>NA</td>
								</tr>
								<tr>
									<td>Change Language</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Web Disk</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Directory Privacy</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Customizable php.ini</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Cron Jobs</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Simple DNS Zone Editor</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Advanced DNS Zone Editor</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Install Perl Modules</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Install Ruby Gems</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>SSL/TLS Manager</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel3}
				onChange={() => {
					setpanel3(!panel3);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<StorageIcon className="comp-title-icon" /> Server Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>Webserver</td>
									<td>LiteSpeed Enterprise</td>
									<td>LiteSpeed Enterprise</td>
									<td>LiteSpeed Enterprise</td>
								</tr>
								<tr>
									<td>PHP 5.6 - 8.2</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Node.JS 6.X - 14.X</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Python 2.X - 3.X</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Ruby 1.X - 2.X</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>MariaDB 10.X.X</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>CGI</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Perl</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Javascript</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>SSH Access (Jailed)</td>
									<td><Cancel color="error" /></td>
									<td><Cancel color="error" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel4}
				onChange={() => {
					setpanel4(!panel4);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<i class="fa fa-database comp-title-icon"></i>Databases Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>MySQL Databases</td>
									<td>2</td>
									<td>15</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>PHP MyAdmin</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel5}
				onChange={() => {
					setpanel5(!panel5);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<LocalPostOfficeIcon className="comp-title-icon" />
						Email Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>Email Accounts</td>
									<td>2</td>
									<td>15</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Email Forwarders</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>Email Autoresponders</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
									<td>Unlimited</td>
								</tr>
								<tr>
									<td>SMTP, POP3, IMAP</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
								<tr>
									<td>SPF and DKIM Support</td>
									<td>Yes</td>
									<td>Yes</td>
									<td>Yes</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel6}
				onChange={() => {
					setpanel6(!panel6);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
					<SecurityIcon className="comp-title-icon" />
						Statistic/Web Stats
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>AWStats</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Error Logs</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Bandwidth Stats</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Google Analytics Compatible</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel7}
				onChange={() => {
					setpanel7(!panel7);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<i class="fa fa-code comp-title-icon"></i>Scripts
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>Softaculous Script Installer</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Blogs</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Portals/CMS</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Customer Support</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Discussion Boards</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>E-Commerce</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>FAQ</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Hosting Billing</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Image Galleries</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Polls and Surveys</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Project Management</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Site Builders</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Wiki</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel8}
				onChange={() => {
					setpanel8(!panel8);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<i class="fa fa-code comp-title-icon"></i>Account Resources
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>CPU Core</td>
									<td>1</td>
									<td>2</td>
									<td>2</td>
								</tr>
								<tr>
									<td>RAM</td>
									<td>1GB</td>
									<td>2GB</td>
									<td>4GB</td>
								</tr>
								<tr>
									<td>Concurrent connections (EP)</td>
									<td>30</td>
									<td>30</td>
									<td>30</td>
								</tr>
								<tr>
									<td>Number of processes (nPROC)</td>
									<td>100</td>
									<td>100</td>
									<td>100</td>
								</tr>
								<tr>
									<td>IO Limit</td>
									<td>50MBPS</td>
									<td>50MBPS</td>
									<td>50MBPS</td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>

			<Accordion
				expanded={panel9}
				onChange={() => {
					setpanel9(!panel9);
				}}
			>
				<AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
					<Typography>
						<HelpIcon className="comp-title-icon" />
						Support Features
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						<table className="camparision-table">
							<tbody>
								<tr>
									<td>24/7 Live Chat</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>24/7 Help Desk</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Instant Setup</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
								<tr>
									<td>Transfer Assistance</td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
									<td><CheckCircle color="success" /></td>
								</tr>
							</tbody>
						</table>
					</Typography>
				</AccordionDetails>
			</Accordion>
		</div>
	);
}
